import React from 'react'
import { EnergyMode } from '@vacationtracker/shared/types/user-insight'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import { IDepartmentDistribution } from '@vacationtracker/shared/types/team-energy'

interface IDistributionBarProps {
  distribution: IDepartmentDistribution
}

interface ISegment {
  mode: EnergyMode
  count: number
  i18nKey: string
}

const DistributionBar: React.FC<IDistributionBarProps> = ({ distribution }) => {
  const segments: ISegment[] = [
    { mode: EnergyMode.PEAK, count: distribution.peak, i18nKey: 'teamEnergy.status.peak' },
    { mode: EnergyMode.ENERGIZED, count: distribution.energized, i18nKey: 'teamEnergy.status.energized' },
    { mode: EnergyMode.FUNCTIONAL, count: distribution.functional, i18nKey: 'teamEnergy.status.functional' },
    { mode: EnergyMode.STRUGGLING, count: distribution.struggling, i18nKey: 'teamEnergy.status.struggling' },
    { mode: EnergyMode.DRAINED, count: distribution.drained, i18nKey: 'teamEnergy.status.drained' },
  ]
  const totalCount = segments.reduce((sum, s) => sum + s.count, 0)
  const visibleSegments = segments.filter((s) => s.count > 0)

  // No scored members → nothing to distribute; mirror the energy tile's "No data"
  // (shared __mode-name style, so both tiles read identically).
  if (totalCount === 0) {
    return (
      <div className="te-kpi-distribution__mode-name">
        <IntlMessages id="teamEnergy.kpi.noData" />
      </div>
    )
  }

  return (
    <>
      {totalCount > 0 && (
        <div className="te-distribution">
          {visibleSegments.map((segment) => (
            <div key={segment.mode} className={`te-distribution__segment te-distribution__segment--${segment.mode}`} style={{ flex: segment.count }} />
          ))}
        </div>
      )}
      <div className="te-distribution__legend">
        {visibleSegments.map((segment) => (
          <div key={segment.mode} className="te-distribution__legend-item">
            <span className={`te-distribution__legend-dot te-distribution__legend-dot--${segment.mode}`} />
            {segment.count} <IntlMessages id={segment.i18nKey} />
          </div>
        ))}
      </div>
    </>
  )
}

export default DistributionBar
